// Slices.ts

import { z } from "zod";
import { AppSliceSchema } from "../../schemas/slices/AppSliceSchema";
import { FeedbackSliceSchema } from "../../schemas/slices/FeedbackSchema";
import { FeedSliceSchema } from "../../schemas/slices/FeedSliceSchema";
import { PollManagerSliceSchema } from "../../schemas/slices/PollManagerSliceSchema";
import { AbtSliceSchema } from "../../schemas/slices/AbtSliceSchema";
import { GaeSliceSchema } from "../../schemas/slices/GaeSliceSchema";

// _____APP-SLICE
export const appSlice: {
    initial: z.infer<typeof AppSliceSchema>;
    schema: typeof AppSliceSchema;
} = {
    initial: {
        notificationsEnabled: false,
        checkInVoucherAvailable: null,
        checkInRewards: null,
        ratingVoucherAvailable: null,
        stwVoucherAvailable: null,
        globalRewardActivity: null,
        // taskRewards: [],
        streak: null,
        checkInSchedule: null,
        totalTasksCompleted: null,
        totalRewardsEarned: null,
        qaScore: null,
        loading: {
            appSession: true,
            submittingTask: false,
            wheelLoading: false,
        },
        walletAddress: null,
        username: null,
        profilePictureUrl: null,
        notiVoucherAvailable: null,
    },
    schema: AppSliceSchema,
};

// _____FEED-SLICE
export const feedSlice: {
    initial: z.infer<typeof FeedSliceSchema>;
    schema: typeof FeedSliceSchema;
} = {
    initial: {
        items: [],
        returnedItemCount: 0,
        totalItemCount: 0,
        nextCursor: null,
    },
    schema: FeedSliceSchema,
};

// _____ABT-SLICE
export const abtSlice: {
    initial: z.infer<typeof AbtSliceSchema>;
    schema: typeof AbtSliceSchema;
} = {
    initial: {
        isSkeletonRendering: true,
        abTests: [],
        myAbTests: [],
        availableRewards: {
            count: 0,
            lastClaimedAt: null,
            canClaimAt: null,
            breakdown: [],
        },
    },
    schema: AbtSliceSchema,
};

// _____GAE-SLICE
export const gaeSlice: {
    initial: z.infer<typeof GaeSliceSchema>;
    schema: typeof GaeSliceSchema;
} = {
    initial: {
        isSkeletonRendering: true,
        data: null,
    },
    schema: GaeSliceSchema,
};

// _____POLL-MANAGER-SLICE
export const pollManagerSlice: {
    initial: z.infer<typeof PollManagerSliceSchema>;
    schema: typeof PollManagerSliceSchema;
} = {
    initial: {
        activeConversationId: null,
        conversations: {},
        meta: {},
    },
    schema: PollManagerSliceSchema,
};

// _____FEEDBACK-SLICE
export const feedbackSlice: {
    initial: z.infer<typeof FeedbackSliceSchema>;
    schema: typeof FeedbackSliceSchema;
} = {
    initial: {} as Record<string, never>,
    schema: FeedbackSliceSchema,
};

// ___SLICES
export const Slices = {
    appSlice,
    feedbackSlice,
    feedSlice,
    abtSlice,
    pollManagerSlice,
    gaeSlice,
};

// _____VALIDATE ALL INITIAL STATES
(() => {
    Object.entries(Slices).forEach(([sliceName, slice]) => {
        const result = slice.schema.safeParse(slice.initial);
        if (!result.success) {
            throw new Error(
                `Initial state validation failed for slice "${sliceName}": ${result.error}`,
            );
        }
    });
})();
